import Immutable from 'immutable';

import * as types from '../actions/actionTypes';

export const initialState = Immutable.List();

const bidReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_BIDS_SUCCESS: {
      return Immutable.List(action.bids);
    }
    default: {
      return state;
    }
  }
};

export default bidReducer;



// WEBPACK FOOTER //
// ./src/reducers/bidReducer.js